(function (ws) {
    'use strict';
    ws.views.customeravailability = ws.views.simpleTable.extend({

        /**
         * Events
         */
        events: {
            'click .search-customer-availability': 'searchFilter',
            'keyup .manufacturer-sku': 'toggleDisable',
            'click .tbl-magnifying': 'toggleSearchIcon',
            'click .chkbox-selectAll': 'toggleAllCheckboxes',
            'keyup .project-number': 'toggleDisable',
            'click .add-cart-btn': 'addToCart',
            'click .custom-checkbox': 'disabledCheckbox',
            'click .download-stock': 'downloadCustomOwnedStock',
            'click .cmnClsDataBindStock': 'checkSelectAllCheckbox'
        },

        /**
         * Constructor
         */
        initialize: function () {
            this.$tableDuplicateHeader = this.$('#customer-owned-stock-table');
            this.$customerReservedTable = this.$('#customer-reserved-stock-table');
            this.$customerDestributedTable = this.$('#customer-distributed-stock-table');
            this.$table = this.$tableDuplicateHeader;
            this.overrideFilterRequest = true;
            this.confirmModalId = this.$('.crt-clear-confirm').attr('id');
            this.$skuInputValue = this.$('.manufacturer-sku');
            this.$projectNumber = this.$('.project-number');
            this.$applyFilterBtn = this.$('.search-customer-availability');
            this.rowTemplate = this.$('#customerAvailability-table-row');
            ws.views.simpleTable.prototype.initialize.call(this);
            this.toggleDisable();
            $('.customer-availability-table').hide();
            this.noResultDistribute = $('.noresult-customeravailability-distributed');
            this.noResultOwned = $('.noresult-customeravailability-owned');
            this.noResultReserved = $('.noresult-customeravailability-reserved');
            this.pdpContainer = $('.row-product-description');
            this.pdpDetailTemplate = _.template($('#bufferstock-data-section').html());
            this.multiViewEnabled = this.$('#multiViewEnabled').val();
            this.add3plButton = this.$('.add-cart-btn');
            this.customerOwned = this.$('.download-stock');
            this.$quantityError = this.$('.quantityError');
            this.$cartError = this.$('.cartError');
            this.$cartSuccess = this.$('.cartSuccess');
            this.$selectAllCheckboxCustomerOwned = this.$('.owned-checkbox-selectAll');
            this.$selectAllCheckboxReserved = this.$('.reserved-checkbox-selectAll');
            this.$selectAllCheckboxBuffer = this.$('.buffer-checkbox-selectAll');
            this.add3plButton.hide();
            this.customerOwned.hide();
            this.threePLDownloadStockURL = globals.path.api.westcon.threePLDownloadStockURL;
            $('.yes').on('click', this.clearCart.bind(this));
            $('.switch-user').on('click', this.switchUser.bind(this));
            this.cart3plEligible = this.$('.crt-3pl-eligible-confirm').attr('id');
            this.addedCartSuccessModal = this.$('.crt-added-success').attr('id');

            // SORTING FUNCTION FOR DATATABLE DATE COLUMN
            /*jQuery.extend( jQuery.fn.dataTableExt.oSort, {
                "date-uk-pre": function ( a ) {
                        var getDate = a.split('/');
                        if (getDate.length < 3) {
                            return '';
                        } else {
                            return (getDate[2] + getDate[1] + getDate[0]);
                        }
                },
                "date-uk-asc": function ( a, b ) {
                    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
                },
                "date-uk-desc": function ( a, b ) {
                    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
                }
            });*/

        },

        /**
         * check value of search input and disable/enable button accordingly
         * @param {Event} e
         */
        toggleDisable: function (e) {
            const disabled = ($.trim(this.$skuInputValue.val()).length === 0) && ($.trim(this.$projectNumber.val()).length === 0);

            $('.search-customer-availability').toggleClass('disabled', disabled);
            $('.search-customer-availability').prop('disabled', disabled);

            //13 enter key code
            if (!disabled && (typeof e !== 'undefined' && e.which === 13)) {
                this.searchFilter();
            }
        },

        /**
         *
         */
        clearCart: function (e) {
            this.eventAgg.trigger(this.confirmModalId + 'close');
            this.addToCart(e, true);
        },

        /**
         *
         */
        disabledCheckbox: function (e) {
            if ($(e.target).hasClass('ca-availability-checkbox') || $(e.target).hasClass('owned-checkbox-selectAll')) {
                this.add3plButton.attr('disabled', this.$('.ca-availability-checkbox:checked').length > 0 ? false : true);
                $('.ownedCls').attr('disabled', this.$('.ca-availability-checkbox:checked').length > 0 ? false : true);
            }

        },

        /**
         * Change the state of all the checkboxes in the 3PL table table.
         * @param {Object} ev
         */
        toggleAllCheckboxes: function (ev) {
            var currClassChild;
            var currentClassParent;
            if ($(ev.target).hasClass('owned-checkbox-selectAll')) {
                currClassChild = 'ca-availability-checkbox';
                currentClassParent = 'owned-checkbox-selectAll';
            } else if ($(ev.target).hasClass('reserved-checkbox-selectAll')) {
                currClassChild = 'reserved-checkbox';
                currentClassParent = 'reserved-checkbox-selectAll';
                this.toggleDownloadStockBtn(currClassChild, 'reservedCls');
            } else if ($(ev.target).hasClass('buffer-checkbox-selectAll')) {
                currClassChild = 'buffer-checkbox';
                currentClassParent = 'buffer-checkbox-selectAll';
                this.toggleDownloadStockBtn(currClassChild, 'bufferCls');
            }

            var $checkboxes = this.$('.' + currClassChild).not(':disabled');
            var $checkboxAll = this.$('.' + currentClassParent);
            _.each($checkboxes, function(checkbox) {
                $(checkbox).prop('checked', $checkboxAll.is(':checked'));
            });

            if ($(ev.target).hasClass('reserved-checkbox-selectAll')) {
                this.toggleDownloadStockBtn(currClassChild, 'reservedCls');
            }

            if ($(ev.target).hasClass('buffer-checkbox-selectAll')) {
                this.toggleDownloadStockBtn(currClassChild, 'bufferCls');
            }
        },

        toggleDownloadStockBtn: function(val, btnVal) {
            var checkBoxCurr = this.$('.' + val);
            _.each(checkBoxCurr, function(checkbox) {
                if ($(checkbox).is(':checked')) {
                    $('.' + btnVal).attr('disabled', false);
                } else {
                    $('.' + btnVal).prop('disabled', true);
                }
            });
        },

        switchUser: function (e) {
            if (this.$('#isAccountMngr').val() === 'true') {
                window.location.href = globals.path.api.westcon.resellerSearchUrl;
            } else {
                $.when(this.eventAgg.trigger(this.cart3plEligible + 'close'))
                    .then(function() {
                        $(window).scrollTop($('#page').offset().top);
                    }).then(function() {
                        setTimeout(function() {
                            $('.icon-downarrow').click();
                        }, 0);
                    });
            }
        },

        downloadCustomOwnedStock: function (e, p) {
            var rowOptions;
            var rowParams = [];
            var stockData = '';
            var xlsFileName = '';
            var clsName = '';
            this.error = false;
            globals.disableApp();

            if ($(e.target).attr('name') === 'CustomerStock') {
                stockData = 'CustomerStock';
                xlsFileName = 'Customer_Owned_Stock.xlsx';
                clsName = 'ca-availability-checkbox';
            } else if ($(e.target).attr('name') === 'ReservedStock') {
                stockData = 'ReservedStock';
                xlsFileName = 'Reserved_Stock.xlsx';
                clsName = 'reserved-checkbox';
            } else if ($(e.target).attr('name') === 'BufferStock') {
                stockData = 'BufferStock';
                xlsFileName = 'Buffer_Stock.xlsx';
                clsName = 'buffer-checkbox';
            }

            if (false) {
                console.log('ignore');
            } else {
                _.each(this.$('.' + clsName + ':checked'), function (row) {

                    let element = $(row).closest('tr');
                    let qtyElement = element.find('.sku-quantity');

                    //let qtyInput = parseInt(qtyElement.val());
                    // let availability = parseInt(element.find('.availability').text().trim());

                    // if (!_.isNumber(qtyInput) || parseInt(qtyInput) <= 0 || parseInt(qtyInput) > availability || isNaN(qtyInput)) {
                    //     qtyElement.addClass('error');
                    //     this.$quantityError.show();
                    //     this.error = true;
                    // }

                    rowOptions = {
                        //qty: element.find('.sku-quantity').val(),
                        availability: element.find('.availability').text().trim(),
                        category: element.find('.category').text().trim(),
                        customerPrice: element.find('.customerPrice').text().trim(),
                        description: element.find('.ord-longDescription').text().trim(),
                        discount: element.find('.discount').text().trim(),
                        listPrice: element.find('.listPrice').text().trim(),
                        manufacturer: element.find('.manufacturer').text().trim(),
                        manufacturePartNo: element.find('.manufacturePartNo').text().trim(),
                        projectNumber: element.find('.projectId') ? element.find('.projectId').text().trim() : ''
                    };

                    rowParams.push(rowOptions);
                }.bind(this));

                const CSRFToken = $('#CSRFToken').val();
                const urlExportOrderList = this.threePLDownloadStockURL + '?CSRFToken=' + CSRFToken;
                const data = {
                    stockData: rowParams, stockType: stockData
                };

                // DOWNLOADING EXCEL FILE FROM THE BLOB.
                const xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function() {
                    var a;
                    if (xhttp.readyState === 4 && xhttp.status === 200) {
                        // Trick for making downloadable link
                        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                            navigator.msSaveBlob(xhttp.response, xlsFileName);
                        } else {
                            a = document.createElement('a');
                            a.href = window.URL.createObjectURL(xhttp.response);

                            // Give filename you wish to download
                            a.download = xlsFileName;
                            a.style.display = 'none';
                            document.body.appendChild(a);
                            a.click();
                        }

                        //this.checkSelectAllCheckbox();
                        globals.enableApp();
                    }
                };

                xhttp.open('POST', urlExportOrderList);
                xhttp.setRequestHeader('Content-Type', 'application/json');
                xhttp.responseType = 'blob';
                xhttp.send(JSON.stringify(data));
            }
        },

        checkSelectAllCheckbox (e) {
            let getClickedClass;
            let getCheckboxedClass;

            if ($(e.target).hasClass('ca-availability-checkbox')) {
                getClickedClass = 'ca-availability-checkbox';
                getCheckboxedClass = this.$selectAllCheckboxCustomerOwned;
            } else if ($(e.target).hasClass('reserved-checkbox')) {
                getClickedClass = 'reserved-checkbox';
                getCheckboxedClass = this.$selectAllCheckboxReserved;
                this.$('.reservedCls').attr('disabled', this.$('.reserved-checkbox:checked').length > 0 ? false : true);
            } else if ($(e.target).hasClass('buffer-checkbox')) {
                getClickedClass = 'buffer-checkbox';
                getCheckboxedClass = this.$selectAllCheckboxBuffer;
                this.$('.bufferCls').attr('disabled', this.$('.buffer-checkbox:checked').length > 0 ? false : true);
            }

            const totalCheckboxes = $('.' + getClickedClass).not(':disabled').length;
            const selectedCheckboxes = $('.' + getClickedClass + ':checked').not(':disabled').length;
            if (selectedCheckboxes === 0) {
                getCheckboxedClass.prop('checked', false);
            } else {
                getCheckboxedClass.prop('checked', totalCheckboxes === selectedCheckboxes);
            }

        },

        /**
         *
         */
        addToCart: function (e, proceed) {
            var rowOptions;
            var rowParams = [];
            var projectId;
            this.error = false;

            if (this.$('#configuredResellers').val() !== '' && this.$('#configuredResellers').val() !== null) {
                this.eventAgg.trigger(this.cart3plEligible);
            } else {
                _.each(this.$('.ca-availability-checkbox:checked'), function (row) {

                    let element = $(row).closest('tr');
                    let qtyElement = element.find('.sku-quantity');
                    let qtyInput = parseInt(qtyElement.val());
                    let availability = parseInt(element.find('.availability').text().trim());

                    if (!_.isNumber(qtyInput) || parseInt(qtyInput) <= 0 || parseInt(qtyInput) > availability || isNaN(qtyInput)) {
                        qtyElement.addClass('error');
                        this.$quantityError.show();
                        this.error = true;
                    }

                    rowOptions = {
                        qty: element.find('.sku-quantity').val(),
                        productCode: element.find('.manufacturePartNo').text().trim(),
                        projectNumber: element.find('.projectId').text().trim()
                    };

                    rowParams.push(rowOptions);
                }.bind(this));

                if (!this.error) {
                    this.$quantityError.hide();
                    this.$('.sku-quantity').removeClass('error');
                    const model = new ws.models.threePLCartModel();
                    model.set({
                        proceed: proceed ? true : false,
                        entryData: rowParams
                    });

                    this.add3plButton.addClass('spinner-after');
                    this.add3plButton.attr('disabled', true);
                    this.$('.ownedCls').attr('disabled', true);
                    model.save()
                        .done(response => {
                            if (!response.error) {
                                this.$cartError.html('').hide();
                                this.add3plButton.removeClass('spinner-after');
                                if (response.isCartBlock) {
                                    this.add3plButton.attr('disabled', false);
                                    this.eventAgg.trigger(this.confirmModalId);
                                } else {
                                    this.eventAgg.trigger(this.addedCartSuccessModal);
                                    this.eventAgg.trigger('updateCart', response.miniCartData);
                                    this.$('.sku-quantity').val(0);
                                    this.$('.ca-availability-checkbox').prop('checked', false);
                                    this.$('.ca-availability-checkbox').prop('disabled', false);
                                    this.$selectAllCheckboxCustomerOwned.prop('checked', false);
                                }
                            } else {
                                this.$cartError.html('');
                                this.add3plButton.removeClass('spinner-after');
                                this.$cartError.html(response.error).show();
                            }
                        });
                }
            }
        },

        /**
         * check value of search input and Triggering the search call
         * @param {Event} e
         */
        toggleSearchIcon: function (e) {
            const disabled = ($.trim(this.$skuInputValue.val()).length === 0) && ($.trim(this.$projectNumber.val()).length === 0);

            $('.search-customer-availability').toggleClass('disabled', disabled);
            $('.search-customer-availability').prop('disabled', disabled);

            if (!disabled) {
                this.searchFilter();
            }
        },

        /**
         * Call Search Filter API
         * @param {Object} request
         */
        searchFilterCall: function (request) {
            if (['true', true].includes($('#customerStockSolrEnabled').val())) {
                request = {
                    manufacturerPart: $('.manufacturer-sku').val(),
                    projectNumber: $('.project-number').val(),
                    accountNumber: dataLayerAA.reseller.id,
                    salesOrg: dataLayerAA.salesOrg
                };
            }

            this.model.set(request);
            if (['true', true].includes($('#customerStockSolrEnabled').val())) {
                this.model.url = globals.path.api.westcon.searchCustomerStock;
            } else {
                this.model.url = globals.path.api.westcon.customerAvailabilitySearchUrl;
            }

            $('.tbl-simple-header').hide();
            $('.tbl-simple-page').hide();
            globals.disableApp();

            //clear table of rows
            this.$tableSpinner.hide();
            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();
            this.noResultReserved.hide();
            this.noResultOwned.hide();
            this.noResultDistribute.hide();
            this.$quantityError.hide();
            this.enableDelaySpinner();

            this.model.save().done(function (resultData) {
                this.$('.chkbox-selectAll').prop('checked', false);
                this.$('.commonStyleDownload').prop('disabled', true);
                this.$('.add-cart-btn').prop('disabled', true);
                this.disabledDelaySpinner();
                globals.enableApp();
                if (['true', true].includes($('#customerStockSolrEnabled').val())) {
                    resultData.bufferStockProduct = resultData.stockHeaderInformation;
                    resultData.customerOwnedStockData = resultData.customerOwnedStock;
                    resultData.customerReservedStockData = resultData.customerReservedStock;
                    resultData.distributionStockData = resultData.distributedStock;
                }

                if (resultData.length === 0) {
                    this.handleEmptyErrorMessage();
                    this.$tableSpinner.hide();
                } else {

                    if (resultData.amCustomer == true) {
                        resultData.hasZ3PCGroup = true;
                        resultData.hasZCRCGroup = true;
                    }

                    var flagOwnedStock = false;
                    var flagBufferStock = false;
                    var flagReservedStock = false;

                    $('.customer-availability-table').show();
                    if (resultData.distributionStockMsg) {
                        $('.distributed-stock-header').text(resultData.distributionStockMsg);
                    } else {
                        $('.distributed-stock-header').text($('#headerIdText').val());
                    }

                    // Passing the buffer stock product value to pdpdetail template
                    if (resultData.bufferStockProduct != null) {
                        resultData.bufferStockProduct.maxAvailabilityRows = this.getMaxRowCount(resultData.bufferStockProduct.productStockAvailabilityData);
                        resultData.bufferStockProduct.futureAvailabilityCount = this.hasFutureAvailability(resultData.bufferStockProduct.productStockAvailabilityData);
                        this.pdpContainer.show();
                        this.pdpContainer.html(this.pdpDetailTemplate({bufferStockProduct: resultData.bufferStockProduct}));
                    } else {
                        this.pdpContainer.hide();
                    }

                    $('.owned-stock').show();
                    this.$table = this.$tableDuplicateHeader;
                    this.rowTemplate = this.$('#customerAvailability-table-row');
                    this.$table.dataTable().fnClearTable();
                    this.$table.DataTable().destroy();
                    if (resultData.hasZ3PCGroup == false) {
                        $('.owned-stock').hide();
                    } else {
                        if (resultData.customerOwnedStockData != null) {
                            if (resultData.customerOwnedStockData.length != 0) {
                                let result = resultData.customerOwnedStockData;
                                if (!['true', true].includes($('#customerStockSolrEnabled').val())) {
                                    result = resultData.customerOwnedStockData.filter(row => row.availability > 0 || row.availability);
                                }

                                if (!['true', true].includes($('#customerStockSolrEnabled').val())) {
                                    _.each(result, (item) => {
                                        if (item.eta !== null) {
                                            item.etaString = item.eta.split('/').reverse().join('');
                                        } else {
                                            item.eta = '';
                                            item.etaString = '01/01/1990'.split('/').reverse().join('');
                                        }
                                    });
                                }

                                this.renderRows(result, true);
                                if ($('#customer-owned-stock-table').find('th.control').is(':visible')) {
                                    flagOwnedStock = true;
                                }

                                this.add3plButton.show();
                                this.customerOwned.show();
                                this.$('.ownSelAll').prop('checked', false).show();
                            } else {
                                this.noResultOwned.show();
                                this.add3plButton.hide();
                                this.customerOwned.hide();
                                this.$('.ownSelAll').prop('checked', false).hide();
                            }
                        } else {
                            this.noResultOwned.show();
                            this.add3plButton.hide();
                            this.customerOwned.hide();
                            this.$('.ownSelAll').prop('checked', false).hide();
                        }
                    }

                    $('.reserved-stock').show();
                    this.$table = this.$customerReservedTable;
                    this.rowTemplate = this.$('#customerAvailability-reserved-table-row');
                    this.$table.dataTable().fnClearTable();
                    this.$table.DataTable().destroy();
                    if (resultData.hasZCRCGroup == false) {
                        $('.reserved-stock').hide();
                    } else {
                        if (resultData.customerReservedStockData != null) {
                            if (resultData.customerReservedStockData.length !== 0) {
                                if (!['true', true].includes($('#customerStockSolrEnabled').val())) {
                                    _.each(resultData.customerReservedStockData, (item) => {
                                        if (item.eta !== null) {
                                            item.etaString = item.eta.split('/').reverse().join('');
                                        } else {
                                            item.eta = '';
                                            item.etaString = '01/01/1990'.split('/').reverse().join('');
                                        }
                                    });
                                }

                                this.$('.reservedCls').show();
                                this.$('.rsrvdSelAll').prop('checked', false).show();
                                this.renderRows(resultData.customerReservedStockData);
                                if ($('#customer-reserved-stock-table').find('th.control').is(':visible')) {
                                    flagReservedStock = true;
                                }
                            } else {
                                this.noResultReserved.show();
                                this.$('.reservedCls').hide();
                                this.$('.rsrvdSelAll').prop('checked', false).hide();
                            }
                        } else {
                            this.noResultReserved.show();
                            this.$('.reservedCls').hide();
                            this.$('.rsrvdSelAll').prop('checked', false).hide();
                        }
                    }

                    this.$table = this.$customerDestributedTable;
                    this.rowTemplate = this.$('#distributedAvailability-table-row');
                    this.$table.dataTable().fnClearTable();
                    this.$table.DataTable().destroy();
                    if (resultData.distributionStockData != null) {
                        if (resultData.distributionStockData.length != 0) {
                            if (!['true', true].includes($('#customerStockSolrEnabled').val())) {
                                _.each(resultData.distributionStockData, (item) => {
                                    if (item.eta !== null) {
                                        item.etaString = item.eta.split('/').reverse().join('');
                                    } else {
                                        item.eta = '';
                                        item.etaString =  '01/01/1990'.split('/').reverse().join('');
                                    }
                                });
                            }

                            this.renderRows(resultData.distributionStockData);
                            if ($('#customer-distributed-stock-table').find('th.control').is(':visible')) {
                                flagBufferStock = true;
                            }

                            _.each(this.$('[data-view="tooltipModal"]'), function ($el) {
                                new ws.views.tooltipModal({
                                    el: $el
                                });
                            });
                            this.$('.bufferSelAll').prop('checked', false).show();
                            this.$('.bufferCls').show();
                        } else {
                            this.noResultDistribute.show();
                            this.$('.bufferSelAll').prop('checked', false).hide();
                            this.$('.bufferCls').hide();
                        }
                    } else {
                        this.noResultDistribute.show();
                        this.$('.bufferSelAll').prop('checked', false).hide();
                        this.$('.bufferCls').hide();
                    }

                    if (flagOwnedStock === true || flagBufferStock === true || flagReservedStock === true) {
                        // Do nothing
                        $('.customer-availability-tablerow').find('.control').css('visibility', 'visible');
                    } else {
                        $('.customer-availability-tablerow').find('th.control').css('display', 'none');
                    }

                    $('.pdp-gallery-block').html(`<img class="etiliseVendor" src="${resultData.stockHeaderInformation.productImageURL}" alt="string" title="string">`);
                }
            }.bind(this)).fail(function () {
                $('.customer-availability-table').hide();
                this.tableGenericError();
                globals.enableApp();
                this.add3plButton.hide();
                this.customerOwned.hide();
                this.pdpContainer.hide();
            }.bind(this));
        },

        /**
         * Render a table row (what kind of data?)
         * @param {Object} result
         */
        renderRows: function (result, quantity) {
            var options;
            var _this = this;
            let incValue = 0;
            _.each(result, function (row) {
                row.id = incValue;
                incValue++;
                row.multiViewEnabled = _this.multiViewEnabled;
                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable(true, quantity);

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        /**
         * Gets max row count of sapAvailabilityList
         * @param {Object} data
         * @returns {integer} maxRows
         */
        getMaxRowCount: function (data) {
            var maxObj = _.max(data, function (availability) {
                return (availability.futureAvailability && availability.futureAvailability.length) || 0;
            });

            return (maxObj.futureAvailability && maxObj.futureAvailability.length) || 0;
        },

        /**
         * Returns number of sapAvailabilityList items that has futureAvailability items inside
         * @param {Object} data
         * @returns {integer} futureAvailabilityCount
         */
        hasFutureAvailability: function (data) {
            return _.reduce(data, function (memo, sapData) {
                var futureAvailabilityCount = sapData.futureAvailability && sapData.futureAvailability.length;
                return memo + (futureAvailabilityCount ? 1 : 0);
            }, 0);
        },

        /**
         * Handling error messages
         */
        handleEmptyErrorMessage: function () {
            $('.noresult-customeravailability').show();
        },

        /**
         * Override filter request object
         */
        customFilterRequest: function () {
            const request = {};
            request.manufacturerPart = $('.manufacturer-sku').val();
            request.projectNumber = $('.project-number').val();
            return request;
        },

        disableFutureDate: true
    });
})(westcon);
